import React, {Fragment, useMemo, useState} from 'react';
import { Icon, Icons, Flex, Breadcrumbs, Link, Layout, Form, Edit, List, Redirect, Button, Separator } from 'components';
import {debounce, useNamedSelector} from 'helpers';
import {EditListItems} from ".";
import {updateListAndItems} from "store/lists";
import {TwitterPicker} from "react-color";
import css from './edit.module.scss';

export function EditForm({id, modal, context = {}}) {
  const { list, items = [] } = useNamedSelector('lists.details', { id: id, context: 'lists' });
  const [color, setColor] = useState(list?.color || '#000000');
  const [showColorPicker, setShowColorPicker] = useState(false);

  const initialValues = useMemo(() => ({
    name: context.list?.name || '',
    items: items.filter(hasName),
    color: context.list?.color || '#000000',
    ...list,
  }), [ id, color ]);

  const onChange = useMemo(() => {
    return id ? debounce(updateListAndItems, 1000) : updateListAndItems;
  }, [ id ]);

  const colorChanged = (c) => {
    setShowColorPicker(!showColorPicker);
    setColor(c.hex);
    updateListAndItems({...list, color: c.hex});
  };

  const colorPicker = (color) => {
    return (
      <div
        style={{background: color}}
        className={css.colorPicker}
        onClick={ toggleColorPicker }
      >
      </div>
    );
  }

  const toggleColorPicker = (e) => {
    e.stopPropagation();
    setShowColorPicker(!showColorPicker);
  };

  return (
    <Fragment>
      {id && !list && !modal && <Redirect to="/lists/"/>}

      <Layout.Header justified>
        <Breadcrumbs>
          {context.list && <Link to="/lists/">Lists</Link>}
          {context.list && <Link to={`/lists/${context.list.id}/`}>{context.list.name}</Link>}
          <Link to="/lists/">List</Link>
          <span>
            <b>{id ? 'Edit' : 'Add'} </b>
          </span>
        </Breadcrumbs>
        {!modal &&
          <Button className={['secondary', 'small', !id && 'invisible']} icon="plus" to={'/lists/add/'}>
            Add New List
          </Button>
        }
      </Layout.Header>

      <div className="spacing">
        { id
            ?
            <Form id="listForm" initialValues={initialValues} onChange={onChange} delay>
              <List small-gutter>
                <Fragment>
                  <Edit
                    Prefix={ (e) => colorPicker(list.color, e) }
                    name="name"
                    placeholder="Name"
                    bold  />
                  <TwitterPicker
                    className={ showColorPicker ? css.colorPickerPopupShow : css.colorPickerPopup }
                    color={ color }
                    onChange={ colorChanged }
                  />
                </Fragment>
                <Fragment>
                  <Separator heading="List Items"/>
                  <EditListItems name="items" />
                </Fragment>
              </List>
            </Form>
          :
            <Form id="listForm" onSubmit={updateListAndItems}>
              <List small-gutter>
                <Fragment>
                  <Edit name="name" placeholder="Name" bold autoFocus={true}/>
                </Fragment>
              </List>
            </Form>
        }
      </div>
      {
        !id &&
        <Flex className={['right', 'spacing', 'small']}>
          <Button form="listForm" className="primary" type="submit">Save</Button>
        </Flex>
      }
    </Fragment>
  )
}

function hasName({ name = '' }) {
  return Boolean(name.trim());
}
